"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.headerDictionary = void 0;
exports.headerDictionary = {
    apps: 'Apps',
    searchInputLabel: 'Accessibility label - Search',
    expandMenuItem: 'Accessibility label - Expand menu item',
    closeButton: 'Accessibility label - Close button',
    searchCountryReset: 'Accessibility label - Reset search',
    searchCountryLabel: 'Accessibility label - Enter country name',
    searchOpen: 'Accessibility label - Open the searchbar',
    menuReturn: 'Accessibility label - Menu return',
    menuOpen: 'Accessibility label - Menu open',
    moreProducts: 'More Products',
    search: 'Search',
    allProducts: 'All products',
    communicationErrorMessage: 'Communication Error Message',
    login: 'Dip - Log in',
    logout: 'Dip - Log out',
    yourProfile: 'Dip - Your profile',
    yourDetails: 'Dip - Your details',
    passwordAndPrivacy: 'Dip - Password and privacy',
    zeroResultMessage: 'Search Results - Zero Result Message',
    openLocationMenu: 'Accessibility label - Open location menu',
    closeLocationMenu: 'Accessibility label - Close location menu',
    locationTitle: 'Geo region - Select your location',
    locationDescription: 'Geo region - Choose your preferred location or language for a more personalized experience.',
    locationLinkLabel: 'Geo region - Go to site',
    selectLocation: 'Geo region - Select location',
    selectLanguage: 'Geo region - Select language',
};
